import React from "react";

export default function Careers() {
  return (
    <div className="page">
      <h1>Careers</h1>
      <p>Explore current job openings and career opportunities at Bizverto.</p>
    </div>
  );
}
